export interface ImportOnboardingRecord {
  snoozedUntil: number;
}

interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

const STORAGE_VERSION = "v1";

export function getImportOnboardingStorageKey(workspaceId: string): string {
  return `pw-onboarding-import:${STORAGE_VERSION}:${workspaceId}`;
}

export function readImportOnboardingRecord(
  workspaceId: string | undefined,
  storage: StorageLike | undefined,
): ImportOnboardingRecord | null {
  if (!workspaceId || !storage) return null;
  try {
    const raw = storage.getItem(getImportOnboardingStorageKey(workspaceId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ImportOnboardingRecord>;
    if (typeof parsed.snoozedUntil !== "number") return null;
    return { snoozedUntil: parsed.snoozedUntil };
  } catch {
    return null;
  }
}

export function writeImportOnboardingRecord(
  workspaceId: string | undefined,
  record: ImportOnboardingRecord,
  storage: StorageLike | undefined,
): void {
  if (!workspaceId || !storage) return;
  try {
    storage.setItem(getImportOnboardingStorageKey(workspaceId), JSON.stringify(record));
  } catch {
    // Ignore private mode / quota / disabled storage failures.
  }
}

export function isImportOnboardingSnoozed(
  record: ImportOnboardingRecord | null,
  now = Date.now(),
): boolean {
  if (!record) return false;
  return record.snoozedUntil > now;
}
